import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Button } from '@mui/material';
import PlusCircleIcon from '../../../../../assets/v2/PlusCircleIcon';
import { StyledMenu } from './Filters.styles';
import { useTableFilters } from '../../../Table/providers/TableContext';

function Filters({ children }) {
  const { setFiltersActiveSubmenu } = useTableFilters();
  const [menuAnchor, setMenuAnchor] = useState();
  const isMenuOpen = Boolean(menuAnchor);

  const handleMenuClose = () => {
    setMenuAnchor(null);
    setFiltersActiveSubmenu(null);
  };

  const handleMenuOpen = (event) => {
    setMenuAnchor(event.currentTarget);
  };

  return (
    <>
      <Button
        variant="text"
        className={isMenuOpen ? 'Mui-active' : ''}
        size="small"
        startIcon={<PlusCircleIcon />}
        onClick={handleMenuOpen}
      >
        Add Filter
      </Button>
      <StyledMenu
        anchorEl={menuAnchor}
        hasSubmenu
        open={isMenuOpen}
        onClose={handleMenuClose}
      >
        {children}
      </StyledMenu>
    </>
  );
}

Filters.propTypes = {
  children: PropTypes.node,
};

export default Filters;
